/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ServiceCategoryListResponse } from '../../models/service-category-list-response';

export interface ServiceControllerGetAllCategories$Params {
  name?: string;
  service_name?: string;
  service_identifier?: string;
  limit?: number;
  skip?: number;
}

export function serviceControllerGetAllCategories(http: HttpClient, rootUrl: string, params?: ServiceControllerGetAllCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategoryListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, serviceControllerGetAllCategories.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('service_name', params.service_name, {});
    rb.query('service_identifier', params.service_identifier, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ServiceCategoryListResponse;
      }>;
    })
  );
}

serviceControllerGetAllCategories.PATH = '/service/category';
